// extracted by mini-css-extract-plugin
module.exports = {"subfooter":"footer-module--subfooter--3EDKW"};